import { render, staticRenderFns } from "./invoice-mark-as-paid-modal.vue?vue&type=template&id=22745de6&scoped=true&"
import script from "./invoice-mark-as-paid-modal.ts?vue&type=script&lang=ts&"
export * from "./invoice-mark-as-paid-modal.ts?vue&type=script&lang=ts&"
import style0 from "./invoice-mark-as-paid-modal.scss?vue&type=style&index=0&id=22745de6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22745de6",
  null
  
)

export default component.exports